(function () {
  const PARTICLE_PROXY_URL =
    "https://coffee-particle.lebrewtech.com/proxy/particle-detect";

  async function detectParticleFromShopify(file, detectType) {
    if (!(file instanceof File)) {
      throw new Error("A browser File object is required.");
    }

    if (![0, 1].includes(detectType)) {
      throw new Error("detectType must be 0 (powder) or 1 (bean).");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("detect_type", String(detectType));

    const response = await fetch(PARTICLE_PROXY_URL, {
      method: "POST",
      body: formData
    });

    const result = await response.json();

    if (!response.ok || result.code !== 200) {
      throw new Error(result.msg || "Particle detection failed.");
    }

    return result;
  }

  async function bindParticleForm(form) {
    const scope = form.closest(".particle-detect-demo") || form.parentElement || document;
    const fileInput = form.querySelector('[data-role="particle-file"]');
    const typeInput = form.querySelector('[data-role="particle-detect-type"]');
    const submitButton = form.querySelector('[data-role="particle-submit"]');
    const statusNode = form.querySelector('[data-role="particle-status"]');
    const resultNode = scope.querySelector('[data-role="particle-result"]');

    if (!fileInput || !typeInput || !submitButton || !statusNode || !resultNode) {
      return;
    }

    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      const file = fileInput.files && fileInput.files[0];
      const detectType = Number.parseInt(typeInput.value, 10);

      if (!file) {
        statusNode.textContent = "Please select an image first.";
        return;
      }

      submitButton.disabled = true;
      statusNode.textContent = "Analyzing image...";
      resultNode.textContent = "";

      try {
        const result = await detectParticleFromShopify(file, detectType);
        statusNode.textContent = "Analysis completed.";
        resultNode.textContent = JSON.stringify(result, null, 2);
      } catch (error) {
        statusNode.textContent = error.message || "Request failed.";
      } finally {
        submitButton.disabled = false;
      }
    });
  }

  function bootParticleDetect(root) {
    (root || document)
      .querySelectorAll("[data-particle-detect-form]")
      .forEach(function (form) {
        if (form.dataset.particleDetectBound === "true") {
          return;
        }

        form.dataset.particleDetectBound = "true";
        bindParticleForm(form);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootParticleDetect(document);
    });
  } else {
    bootParticleDetect(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bootParticleDetect(event.target);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    bootParticleDetect(event.target);
  });

  document.addEventListener("shopify:section:select", function (event) {
    bootParticleDetect(event.target);
  });

  window.setTimeout(function () {
    bootParticleDetect(document);
  }, 0);

  window.setTimeout(function () {
    bootParticleDetect(document);
  }, 500);

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll("[data-particle-detect-form]")
      .forEach(function (form) {
        if (form.dataset.particleDetectBound === "true") {
          return;
        }

        form.dataset.particleDetectBound = "true";
        bindParticleForm(form);
      });
  });

  window.ShopifyParticleDetect = {
    detectParticleFromShopify
  };
})();
